import { supabase } from './supabase';
import { User } from '@supabase/supabase-js';

export interface Notification {
  id: string;
  user_id: string;
  type: 'message' | 'follow_request';
  sender_id: string;
  read: boolean;
  created_at: string;
  profiles?: {
    username: string;
    avatar_url: string | null;
  };
}

export async function getUnreadNotificationsCount(type?: 'message' | 'follow_request') {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return 0;
  
  try {
    if (type === 'message') {
      const { count } = await supabase
        .from('direct_messages')
        .select('*', { count: 'exact', head: true })
        .eq('receiver_id', user.id)
        .eq('read', false);
      
      return count || 0;
    }

    if (type === 'follow_request') {
      const { count } = await supabase
        .from('follow_requests')
        .select('*', { count: 'exact', head: true })
        .eq('following_id', user.id)
        .eq('status', 'pending');
      return count || 0;
    }

    const { count } = await supabase
      .from('notifications')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', user.id)
      .eq('read', false);

    return count || 0;
  } catch (error) {
    console.error('Error getting notification count:', error);
    return 0;
  }
}

export async function markNotificationsAsRead(type?: 'message' | 'follow_request') {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const query = supabase
    .from('notifications')
    .update({ read: true })
    .eq('user_id', user.id)
    .eq('read', false);

  if (type) {
    query.eq('type', type);
  }

  const { error } = await query;
  if (error) throw error;
}

export function subscribeToNotifications(
  user: User | null,
  callback: (notification: Notification) => void
) {
  if (!user) return { unsubscribe: () => {} };

  return supabase.channel('notifications')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: `user_id=eq.${user.id}`
      },
      (payload) => {
        callback(payload.new as Notification);
      }
    )
    .subscribe();
}